import type { FieldPresentationProps } from '~/interfaces/FieldPresentationProps'

/** Runtime defaults shared by the labelled field molecules. */
export const fieldPresentationDefaults = {
  disabled: false,
  error: '',
  help: '',
  hint: '',
  label: '',
  name: '',
  required: false,
  serverError: ''
} satisfies Required<FieldPresentationProps>
